export enum SunbedColor {
  Available = 'rgba(215, 255, 152, 0.5)',
  Unavailable = '#ff99a3',
  Reserved = '#fff42e',
  Inactive = '#dbd6d1',
  Disabled = '#0000ff01',
}
